import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import modalActions from '@iso/redux/modal/actions';
import ColorModalWrapper from './ColorModal.styles';
import IntlMessages from '@iso/components/utility/intlMessages';
import { Button, Form, Input, Select } from 'antd';
import { layerObjectService } from '@iso/services';
import styled from "styled-components";
import { objectColors } from '@iso/constants/objectColors';
import L from 'leaflet';

const { TextArea } = Input;
const { closeModal } = modalActions;
const { Option } = Select;

const TextModal = (props) => {
    const [form] = Form.useForm();
    const [fields, setFields] = useState([]);
    const [loadingLayer, setLoadingLayer] = useState(false);


    const handleChangeColorSubmit = () => {
        form
            .validateFields()
            .then(values => {
                setLoadingLayer(true);
                storeText(values);
            })
            .catch(info => {
                console.log('Validate Failed:', info);
                setLoadingLayer(false);
            });
    }
    const storeText = (values) => {
      const data = {
        layer_object: {
          type: props.typeText,
          color:values.layer.color,
          layer_id:props.layerId,
          object:{
            centerPoint: props.pointText,
            text: values.layer.text,
          }
        }
      }
      layerObjectService.storeOrUpdate(data).then(res => {
        if(res.code === '0000'){
          setLoadingLayer(false);
          props.cancelModal();
          form.resetFields();
          props.getDataLayer();
        } else {
          setLoadingLayer(false);
        }
      });
    }

    const renderOptionsColor = () => {
        let options = [];
        _.forEach(objectColors, (color, index) => {
            options.push(
                <Option key={index} value={color.hexCode}>
                    <ColorItemRow>
                        <ColorItemPreview style={{ backgroundColor: color.color }}></ColorItemPreview>
                        <div>{color.label}</div>
                    </ColorItemRow>
                </Option>
            );
        })
        return (
            <Select
                placeholder="Select a color"
                allowClear
                size="large"
            >
                {options}
            </Select>
        );
    }


    return (
        <ColorModalWrapper
            visible={props.isModalVisible}
            onCancel={props.cancelModal}
            maskClosable={false}
            centered
            title={"Text Modal"}
            footer={[
                <Button key="back" onClick={props.cancelModal} className="cancel-button">
                    {<IntlMessages id="propertyPage.modal.cancel" />}
                </Button>,
                <Button key="submit" onClick={handleChangeColorSubmit} loading={loadingLayer} className="btn-success" type="primary">
                    {<IntlMessages id="propertyPage.modal.save" />}
                </Button>,
            ]}
        >
            <Form
              form={form}
              layout="vertical"
              scrollToFirstError
              fields={fields}
            >
                <div className="form-body">
                  <Form.Item
                        name={['layer', 'text']}
                        label="Text"
                        rules={[
                            {
                                required: true,
                                message: 'This field is required',
                            },
                        ]}
                    >
                      <TextArea placeholder="Text" autoSize = {{ minRows: 2 }} />

                    </Form.Item>
                    <Form.Item
                        name={['layer', 'color']}
                        label="Colour"
                        rules={[
                            {
                                required: true,
                                message: 'This field is required',
                            },
                        ]}
                    >
                        {renderOptionsColor()}
                    </Form.Item>
                    
                </div>
            </Form>
        </ColorModalWrapper>
    )
}

export default TextModal;


const ColorItemRow = styled.div`
  display: flex;
  align-items: center;
  line-height: 30px;
  div{
    margin: 4px;
  }
`;

const ColorItemPreview = styled.div`
  width: 16px;
  height: 16px;
  border-radius: 2px;
`;